export default {
    getZoom(state) {
        return state.histoWf;
      },
};
